// extracted by mini-css-extract-plugin
export default {"container":"scroll-wrapper_container__eWi-R"};